import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { FC } from 'react'

import { cn } from '@/app/utils'

import QrCodeForm from './QrCodeForm'

type Props = {
  invoiceId: string
  isQRMethodSelected: boolean
  urlDesc?: string
  urlOffer?: string
  className?: string
}

const BillsPayInformation: FC<Props> = ({
  invoiceId,
  isQRMethodSelected,
  urlDesc = '',
  urlOffer = '',
  className
}) => (
  <div className={cn('font-pro text-20 sm:text-16', className)}>
    {isQRMethodSelected ? (
      <QrCodeForm invoiceId={invoiceId} />
    ) : (
      <>
        <div className="mb-16 flex gap-x-8">
          <ExclamationCircleIcon className="relative top-2 h-24 w-24 flex-shrink-0 text-grey-60" />
          <p>
            Сроки зачисления средств зависят от выбранного способа оплаты.
            Подробнее в{' '}
            <Link href={urlDesc} target="_blank" className="text-bronze-40">
              Информации об оплате картами.
            </Link>
          </p>
        </div>
        <div className="flex gap-x-8">
          <ExclamationCircleIcon className="relative top-2 h-24 w-24 flex-shrink-0 text-grey-60" />
          <p>
            Нажимая кнопку «Оплатить» вы принимаете условия{' '}
            <Link href={urlOffer} target="_blank" className="text-bronze-40">
              Публичной оферты
            </Link>
          </p>
        </div>
      </>
    )}
  </div>
)

export default BillsPayInformation
